var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHorizontalOval3Inline = function SvgHorizontalOval3Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 481,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#horizontal-oval3_inline_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#horizontal-oval3_inline_svg__b)",
    d: "M1288.05 285.227C1157.19 323.385 996.192 381 668.443 381 340.693 381 75 325.11 75 256.167S779.187 100 1106.94 100c327.75 0 329.97 141.823 181.11 185.227Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "horizontal-oval3_inline_svg__b",
    x1: 382.012,
    x2: 2466.34,
    y1: 249.088,
    y2: 361.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#255DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#00A98F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "horizontal-oval3_inline_svg__a",
    width: 1508,
    height: 481,
    x: -25,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_843_5333",
    stdDeviation: 50
  })))));
};
export default SvgHorizontalOval3Inline;